module.exports = __webpack_public_path__ + "img/3.55d14b3a.jpg";